import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Container = styled.li(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: [
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.xxl}`,
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.xxl}`,
    ],
    position: 'relative',
    height: ['96px', '96px', '96px', '108px'],
  }),
);

export const Content = styled.div(() =>
  mq({
    alignItems: 'center',
    verticalAlign: 'middle',
    justifyContent: 'space-between',
  }),
);

export const RaceInfo = styled
  .a(() =>
    mq({
      display: 'flex',
      alignItems: 'center',
    }),
  )
  .withComponent(Link);

export const LeftBox = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '32%',
  }),
);

export const CenterBox = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '28%',
    '> span': {
      fontSize: defaultTheme.font.size.xl,
    },
  }),
);

export const RightBox = styled.div(() =>
  mq({
    paddingTop: '7px',
    paddingBottom: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    width: '40%',
  }),
);

export const RightBoxButton = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    width: '40%',
  }),
);

export const VelodromeName = styled.div(() =>
  mq({
    display: 'block',
    fontSize: [
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
      defaultTheme.font.size.xl,
    ],
  }),
);

export const IconArea = styled.span(() =>
  mq({
    alignItems: 'center',
    verticalAlign: 'text-top',
    paddingLeft: defaultTheme.spacing.xs,
  }),
);

export const RacerName = styled.div(() =>
  mq({
    display: 'block',
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.l,
    ],
  }),
);

export const RacerData = styled.div(() =>
  mq({
    display: 'block',
    fontWeight: 'normal',
    paddingTop: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.s,
    ],
    fontSize: defaultTheme.font.size.s,
  }),
);

export const Times = styled.p(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'row', 'row', 'row'],
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
    ],
    fontWeight: 'normal',
    paddingTop: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.s,
    ],
    lineHeight: '16px',
    marginTop: '2px',
  }),
);

export const DeadLine = styled.span(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.s,
    ],
    paddingLeft: defaultTheme.spacing.s,
    color: defaultTheme.color.primary,
    '& time': {
      marginLeft: defaultTheme.spacing.xs,
    },
  }),
);

export const ResultLink = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: ['80px', '80px', '80px', '110px'],
    height: ['56px', '56px', '56px', '68px'],
    fontSize: [
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
      defaultTheme.font.size.xl,
    ],
    fontWeight: 'bold',
    borderRadius: defaultTheme.border.radius.l,
    color: defaultTheme.color.primary,
    backgroundColor: defaultTheme.background.white,
    border: `2px solid ${defaultTheme.border.color.primary}`,
    ...hoverOpacity,
  }),
);
